module.exports = __webpack_public_path__ + "img/1.fc5bd272.jpg";